<template lang="pug">
  include ../templates/Graph.pug
</template>

<script>
import * as d3 from 'd3'

export default {
  props: {
    data: {
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    xLabelRotate: {
      type: Number,
      default: 0
    },
    xLabelWidth: {
      type: Number,
      default: 100
    },
    xTitle: {
      type: String
    },
    yTitle: {
      type: String
    },
    xFormatter: {
      type: Function,
      default: v => v
    },
    yFormatter: {
      type: Function,
      default: v => v
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  mounted () {
    this.update()
  },
  watch: {
    data (data) {
      this.update(data)
    },
    width () {
      this.update(this.data)
    },
    height () {
      this.update(this.data)
    }
  },
  methods: {
    update () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Graph.vue